module.exports = __webpack_public_path__ + "img/no_notifications.fa421b39.svg";